/**
 * Store validaciones de usuarios y espacio en disco
 *
 */
const state = () => ({
  espacio_disponible: 0,
  cuentas_disponibles: 0,
  plan_contratado: 1,
});

const mutations = {
  setEspacioDisponible(state, data) {
    localStorage.setItem("espacio_disponible", data);
    state.espacio_disponible = data;
  },
  setCuentasDisponibles(state, data) {
    localStorage.setItem("cuentas_disponibles", data);
    state.cuentas_disponibles = data;
  },
  setPlanContratado(state, data) {
    localStorage.setItem("plan_contratado", data);
    state.plan_contratado = data;
  },
};

const getters = {
  getCuentasDisponibles() {
    return localStorage.getItem("cuentas_disponibles");
  },
  getEspacioDisponible() {
    return localStorage.getItem("espacio_disponible");
  },
  getPlanContratado() {
    return localStorage.getItem("plan_contratado");
  },
};

const actions = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
